var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layoutComponent,{tag:"component",attrs:{"model":_vm.model,"editing":_vm.editing,"device":_vm.device}})
}
var staticRenderFns = []

export { render, staticRenderFns }